import { render, staticRenderFns } from "./ClientesPublicidad.vue?vue&type=template&id=58770190&scoped=true&"
import script from "./ClientesPublicidad.vue?vue&type=script&lang=js&"
export * from "./ClientesPublicidad.vue?vue&type=script&lang=js&"
import style0 from "./ClientesPublicidad.vue?vue&type=style&index=0&id=58770190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58770190",
  null
  
)

export default component.exports